
class FEControlCtrl {
  tokenIdWatcher = null;
  // Next steps
  // 1) Actions => Mode (print, edit, preview, mobile?)
  // 2) On Change. Observables?
  // 3) Solve Bindings: setLastToken(z-index patch), cddData, renderSuccess(observable)
  // 4) Handle global exceptions(renderTemplate.validParams)

  // Control behavior heirarchy
  // 1) Valid/Invalid initial state (exceptions)
  // 2) Action (submit, edit, print)
  // 3) Mode? (mobile, static, dynamic)
  // 4) Token Behavior
  // 5) Provider (fieldt5y6)

  constructor($scope, $compile, $element, $injector, TemplateService, $transclude, $rootScope  ) {
    'ngInject';
    this.$scope = $scope;
    this.$compile = $compile;
    this.$element = $element;
    this.$injector = $injector;
    this.ts = TemplateService;
    this.template = undefined;
    this.$transclude = $transclude; 
    this.$rootScope = $rootScope;
    // this.$componentController = $componentController;
  }

  async $onInit() {
    const { template } = await this.ts.getTemplateData();
    this.template = template;
    this.renderControl();
  }
  
  getControl() {
    return this.token.control?.type || 'text-control';
  }
  
  findModel(){
    return this.records[this.token.referenceId][this.token.fieldId];
  }

  renderControl() {
    this.token = this.ts.tokens.find(t => t.id == this.tokenId);
    if (!this.template || !this.token) {
      return;
    }
    let control = this.getControl();
    
    const ngTranscludeCloneAttachFn = (clone, transcludedScope) => { 
      const { token, model, tabNumber, $element, $compile } = this;
      const scope = Object.assign(this.$scope.$new(), {token, model, tabNumber});
      
      const bindings = [
        'token="$ctrl.token"',
        'model="$ctrl.model"',
        'tab-number="$ctrl.tabNumber"'
      ];

      if(control == 'report-control' && clone.length > 0) {
        scope.inner = clone;
        bindings.push(`inner="$ctrl.inner"`);
      }

      const controlTemplate = `<${control} ${bindings.join(' ')}></${control}>`;
      $element.empty().append($compile(controlTemplate)(scope));
    };
    this.$transclude(ngTranscludeCloneAttachFn, null, null);
  }
}

export default {
  bindings: {
    tokenId: "<",  // Token ID
    model: "=",
    records: "=",
    tabNumber: "<?" // Number
  },
  transclude: true,
  templateUrl: "fe-control/fe-control/fe-control.component.html",
  controller: FEControlCtrl
}
